/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpPrestigeTransaction } from './FuelUpPrestigeTransaction';
import {
    FuelUpPrestigeTransactionFromJSON,
    FuelUpPrestigeTransactionFromJSONTyped,
    FuelUpPrestigeTransactionToJSON,
    FuelUpPrestigeTransactionToJSONTyped,
} from './FuelUpPrestigeTransaction';

/**
 * 
 * @export
 * @interface FuelUpPrestigeResponse
 */
export interface FuelUpPrestigeResponse {
    /**
     * 
     * @type {string}
     * @memberof FuelUpPrestigeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FuelUpPrestigeResponse
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    currentLevel: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    totalPrestigePoints: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    lifetimePrestigeCount: number;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpPrestigeResponse
     */
    lastPrestigeAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    nextPrestigeCost: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof FuelUpPrestigeResponse
     */
    activeBonuses?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    totalFuelSacrificed?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    highestPrestigeLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    currentPrestigeStreak?: number;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpPrestigeResponse
     */
    firstPrestigeAt?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof FuelUpPrestigeResponse
     */
    unlockedPrestigeAchievements?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpPrestigeResponse
     */
    canPrestigeNow?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof FuelUpPrestigeResponse
     */
    availableBonuses?: Array<object>;
    /**
     * 
     * @type {Array<FuelUpPrestigeTransaction>}
     * @memberof FuelUpPrestigeResponse
     */
    recentPrestigeHistory?: Array<FuelUpPrestigeTransaction>;
    /**
     * 
     * @type {object}
     * @memberof FuelUpPrestigeResponse
     */
    totalBonusMultipliers?: object;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeResponse
     */
    updatedAt?: number;
}

/**
 * Check if a given object implements the FuelUpPrestigeResponse interface.
 */
export function instanceOfFuelUpPrestigeResponse(value: object): value is FuelUpPrestigeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('currentLevel' in value) || value['currentLevel'] === undefined) return false;
    if (!('totalPrestigePoints' in value) || value['totalPrestigePoints'] === undefined) return false;
    if (!('lifetimePrestigeCount' in value) || value['lifetimePrestigeCount'] === undefined) return false;
    if (!('nextPrestigeCost' in value) || value['nextPrestigeCost'] === undefined) return false;
    return true;
}

export function FuelUpPrestigeResponseFromJSON(json: any): FuelUpPrestigeResponse {
    return FuelUpPrestigeResponseFromJSONTyped(json, false);
}

export function FuelUpPrestigeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpPrestigeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'currentLevel': json['currentLevel'],
        'totalPrestigePoints': json['totalPrestigePoints'],
        'lifetimePrestigeCount': json['lifetimePrestigeCount'],
        'lastPrestigeAt': json['lastPrestigeAt'] == null ? undefined : (new Date(json['lastPrestigeAt'])),
        'nextPrestigeCost': json['nextPrestigeCost'],
        'activeBonuses': json['activeBonuses'] == null ? undefined : json['activeBonuses'],
        'totalFuelSacrificed': json['totalFuelSacrificed'] == null ? undefined : json['totalFuelSacrificed'],
        'highestPrestigeLevel': json['highestPrestigeLevel'] == null ? undefined : json['highestPrestigeLevel'],
        'currentPrestigeStreak': json['currentPrestigeStreak'] == null ? undefined : json['currentPrestigeStreak'],
        'firstPrestigeAt': json['firstPrestigeAt'] == null ? undefined : (new Date(json['firstPrestigeAt'])),
        'unlockedPrestigeAchievements': json['unlockedPrestigeAchievements'] == null ? undefined : json['unlockedPrestigeAchievements'],
        'canPrestigeNow': json['canPrestigeNow'] == null ? undefined : json['canPrestigeNow'],
        'availableBonuses': json['availableBonuses'] == null ? undefined : json['availableBonuses'],
        'recentPrestigeHistory': json['recentPrestigeHistory'] == null ? undefined : ((json['recentPrestigeHistory'] as Array<any>).map(FuelUpPrestigeTransactionFromJSON)),
        'totalBonusMultipliers': json['totalBonusMultipliers'] == null ? undefined : json['totalBonusMultipliers'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function FuelUpPrestigeResponseToJSON(json: any): FuelUpPrestigeResponse {
    return FuelUpPrestigeResponseToJSONTyped(json, false);
}

export function FuelUpPrestigeResponseToJSONTyped(value?: FuelUpPrestigeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'currentLevel': value['currentLevel'],
        'totalPrestigePoints': value['totalPrestigePoints'],
        'lifetimePrestigeCount': value['lifetimePrestigeCount'],
        'lastPrestigeAt': value['lastPrestigeAt'] == null ? undefined : ((value['lastPrestigeAt']).toISOString()),
        'nextPrestigeCost': value['nextPrestigeCost'],
        'activeBonuses': value['activeBonuses'],
        'totalFuelSacrificed': value['totalFuelSacrificed'],
        'highestPrestigeLevel': value['highestPrestigeLevel'],
        'currentPrestigeStreak': value['currentPrestigeStreak'],
        'firstPrestigeAt': value['firstPrestigeAt'] == null ? undefined : ((value['firstPrestigeAt']).toISOString()),
        'unlockedPrestigeAchievements': value['unlockedPrestigeAchievements'],
        'canPrestigeNow': value['canPrestigeNow'],
        'availableBonuses': value['availableBonuses'],
        'recentPrestigeHistory': value['recentPrestigeHistory'] == null ? undefined : ((value['recentPrestigeHistory'] as Array<any>).map(FuelUpPrestigeTransactionToJSON)),
        'totalBonusMultipliers': value['totalBonusMultipliers'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

